// @flow
export default class HomeApplicationIncomeHomie {
  id: string;
  name: string;
  last_name: string;
  second_last_name: string;
  date_of_birth: string;
  rfc: string;
  email: string;
  mobile_phone: string;
  income_amount: string;
  street: string;
  ext_number: string;
  int_number: string;
  neighborhood: string;
  town: string;
  state: string;
  zip: string;
  country: string;
  mayor_medical_expense: string;
  minor_medical_expenses: string;
  car_insurance: string;
  life_insurance: string;
  
  constructor(data: any = {}) {
    data = data !== null ? data : {};
    data.address = data.address ? data.address : {};
    this.id = data.id || '';
    this.name = data.name || '';
    this.last_name = data.last_name || '';
    this.second_last_name = data.second_last_name || '';
    this.date_of_birth = data.date_of_birth || '';
    this.rfc = data.rfc || '';
    this.email = data.email || '';
    this.mobile_phone = data.mobile_phone || '';
    this.income_amount = data.income_amount || '';
    this.street = data.address.street || '';
    this.ext_number = data.address.ext_number || '';
    this.int_number = data.address.int_number || '';
    this.neighborhood = data.address.neighborhood || '';
    this.town = data.address.town || '';
    this.state = data.address.state || '';
    this.zip = data.address.zip || '';
    this.country = data.address.country || '';
    this.mayor_medical_expense = data.mayor_medical_expense || false;
    this.minor_medical_expenses = data.minor_medical_expenses || false;
    this.car_insurance = data.car_insurance || false;
    this.life_insurance = data.life_insurance || false;
  
  }
}
